import { QrCodeTwoTone, AssessmentTwoTone, TuneTwoTone, ContactsTwoTone } from '@mui/icons-material';
import React, { FC, useMemo } from 'react';
import { BottomNavigation, BottomNavigationAction, Box, Tab, Tabs } from '@mui/material';
import { PermissionKeys, useHasPermission, useBreakpoint, SelectOrganisation } from '../../../shared';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Account } from '../account/account.component';
import { AppMenu } from '../app-menu/app-menu.component';

export const Navigation: FC = () => {
    const { t } = useTranslation();
    const { hasPermission } = useHasPermission();
    const location = useLocation();
    const selectedTab = useMemo(() => location.pathname.split('/')[1] || 'registration', [location]);
    const breakPointLg = useBreakpoint('lg');
    const navItems = [
        {
            value: 'registration',
            label: t('registration'),
            hasPermission: hasPermission(PermissionKeys.REGISTRATIONS_WRITE),
            icon: <QrCodeTwoTone />,
        },
        {
            value: 'support',
            label: t('cases'),
            hasPermission: hasPermission(PermissionKeys.SUPPORT_CASES_READ),
            icon: <ContactsTwoTone />,
        },
        {
            value: 'registrations',
            label: t('dailyRegistrations'),
            hasPermission: hasPermission(PermissionKeys.REGISTRATIONS_READ),
            icon: <AssessmentTwoTone />,
        },
        {
            value: 'reports',
            label: t('reports'),
            hasPermission: hasPermission(PermissionKeys.REPORTS_READ),
            icon: <AssessmentTwoTone />,
        },
        {
            value: 'admin',
            to: hasPermission(PermissionKeys.ATTRIBUTES_WRITE) ? 'admin' : 'admin/card-sets',
            label: t('admin'),
            hasPermission:
                hasPermission(PermissionKeys.ATTRIBUTES_WRITE) ||
                hasPermission(PermissionKeys.ORGANISATIONS_WRITE, true),
            icon: <TuneTwoTone />,
        },
    ];

    return breakPointLg ? (
        <>
            <Tabs indicatorColor="primary" textColor="primary" sx={{ flexGrow: 1 }} value={selectedTab}>
                {navItems.map(
                    ({ label, value, to, hasPermission }) =>
                        hasPermission && (
                            <Tab key={value} label={label} value={value} component={Link} to={to || `/${value}`} />
                        ),
                )}
            </Tabs>
            <SelectOrganisation />
            <Account />
            <AppMenu />
        </>
    ) : (
        <>
            <Box sx={{ flexGrow: 1 }} />
            <SelectOrganisation />
            <Account />
            <AppMenu />
            <BottomNavigation showLabels value={selectedTab}>
                {navItems?.map(
                    ({ label, value, icon, hasPermission }) =>
                        hasPermission && (
                            <BottomNavigationAction
                                key={value}
                                label={label}
                                value={value}
                                component={Link}
                                to={`/${value}`}
                                icon={icon}
                            />
                        ),
                )}
            </BottomNavigation>
        </>
    );
};
